import { useEffect, useState } from 'react'
import { api } from '../../../../../services/api'
import { SpaceLoader} from '../../../../loaders/spaceLoader'
import { Button } from '../../../../Button'
import { formatMoney } from '../../../../../Utils/formatMoney'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { toast } from 'react-toastify'

import { Container, ContainerLoading, Table, TotalValue } from './style'

export function CouponDetailedInformations() {
    const idCoupon = useSelector(state => state.modalCentralized.datasComponent.idCoupon)
    const [isLoading, setIsLoading] = useState(true)
    const [couponDetails, setCouponDetails] = useState([])
    const [total, setTotal] = useState('')
    const [discount, setDiscount] = useState('')
    const [quantity, setQuantity] = useState(0)
    const [page, setPage] = useState(1)
    const [loadingNextPage, setLoadingNextPage] = useState(false)

    function seeMoreCouponDetails() {
        setLoadingNextPage(true)

        api.get(`/getCouponDetails/${idCoupon}/${page}`)
        .then(response => {
            const couponDetailsFormatted = response.data.details.map(order => {
                const splitName = order.name.split(' ')
                const nameFormatted = splitName[1] 
                    ? `${splitName[0]} ${splitName[1].split('').slice(0, 1).join('')}.`
                    : order.name

                return {
                    ...order,
                    name: nameFormatted,
                    amount: formatMoney(order.amount),
                    discount: formatMoney(order.discount),
                    date: moment(order.date).format('DD/MM/YYYY HH:mm')
                }
            })

            setCouponDetails(oldCoupons => [...oldCoupons, ...couponDetailsFormatted])
            setPage(response.data.next_page)
        })
        .catch((error) => {
                toast.error('Algo deu errado')
        })
        .finally(() => setLoadingNextPage(false))
    }

    useEffect(() => {
        api.get(`/getCouponDetails/${idCoupon}/1`)
        .then(response => {

            const couponDetailsFormatted = response.data.details.map(order => {
                if(order.name){
                    const splitName = order.name && order.name.split(' ')
                    const nameFormatted = splitName[1] 
                        ? `${splitName[0]} ${splitName[1].split('').slice(0, 1).join('')}.`
                        : order.name
    
                    return {
                        ...order,
                        name: nameFormatted,
                        amount: formatMoney(order.amount),
                        discount: formatMoney(order.discount),
                        date: moment(order.date).utcOffset(0).format('DD/MM/YYYY HH:mm:ss')
                    }
                }
                else{
                    return {
                        ...order,
                        name: order.nomeEmpresaApi,
                        amount: formatMoney(order.amount),
                        discount: formatMoney(order.discount),
                        date: moment(order.date).utcOffset(0).format('DD/MM/YYYY HH:mm:ss')
                    }
                }
            })

            setTotal(formatMoney(response.data.amountTotal))
            setDiscount(formatMoney(response.data.amountDiscount))
            setQuantity(response.data.quantity)

            setCouponDetails(couponDetailsFormatted)
            setPage(response.data.next_page)
        })
        .catch((error) => {
            toast.error('Algo deu errado')
        })
        .finally(() => setIsLoading(false))

        //eslint-disable-next-line
    }, [])


    if(isLoading){
        return(
            <ContainerLoading>
                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        ) 
    }
 
    return (
        <Container>

            <Table>
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Data</th>
                        <th>Valor</th>
                        <th>Desconto</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        couponDetails.length > 0 &&
                        couponDetails.map(order => (
                            <tr key={order.idOrder}>
                                <td>{order.name}</td>
                                <td>{order.date}</td>
                                <td>{order.amount}</td>
                                <td>{order.discount}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
            
            {
                page !== null &&
                <Button 
                    onClick={seeMoreCouponDetails}
                    isLoading={loadingNextPage}
                >
                    Ver mais 
                </Button>
            }

            <TotalValue>
                <div className="blue">
                    <span>Total</span>
                
                    {total}
                </div>    

                <div className="red">
                    <span>Desconto</span>
                
                    {discount}
                </div>

                <div className="green">
                    <span>Cupons</span>
                
                    {quantity}
                </div>
            </TotalValue>
            
        </Container>
    )
}